<template>
  <!-- ホルター心電図解析結果入力 -->
  <div id="HolterAnalysisResult">
    <div id="container-center">
      <div class="switch-area">
        <b-switch class="englishSwitch" size="is-midium" v-model="isChangeEnglish">English</b-switch>
      </div>
      <div class="labelTitle lable">{{isChangeEnglish ? "Input Holter ECG analysis results": "ホルター心電図解析 結果入力"}}</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>{{isChangeEnglish ? "Reception number": "受付番号"}}</th>
            <td><input type="text" v-model="searchConditions.receiptNumber" maxlength="20"/></td>
            <th>{{isChangeEnglish ? "Type": "種別"}}</th>
            <td><select v-model="searchConditions.kind">
                <option></option>
                <option value="301">ホルター心電図配送ｻｰﾋﾞｽ</option>
                <!-- しばらく使わない為非表示7/6 <option value="401">ホルター心電図解析ｻｰﾋﾞｽ</option> -->
              </select>
            </td>
            <!-- ホルター心電図解析申込み画面がリリースされるまで非表示 -->
            <template v-if="false">
              <th>{{isChangeEnglish ? "Analysis method": "解析方法"}}</th>
              <td><select v-model="searchConditions.analysisMethod">
                <option v-for="method in analysisMethodList" :value="method.value" :key="method.value">{{ method.label1 }}</option>
              </select></td>
            </template>
            <th>{{isChangeEnglish ? "Analysis option": "解析オプション"}}</th>
            <td><select v-model="searchConditions.analysisOption" name="解析オプション" >
              <option v-for="analysisOption in analysisOptionList" :value="analysisOption.value" :key="analysisOption.value">{{ analysisOption.label1 }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>{{isChangeEnglish ? "Client": "依頼元"}}</th>
            <td><input type="text" v-model="searchConditions.client" maxlength="256"/></td>
            <th>{{isChangeEnglish ? "Medical institution": "医療機関"}}</th>
            <td><input type="text" v-model="searchConditions.hospital" maxlength="256"/></td>
            <th>{{isChangeEnglish ? "Patient name": "患者名"}}</th>
            <td><input type="text" v-model="searchConditions.patientName" maxlength="100"/></td>
          </tr>
          <tr>
            <th>{{isChangeEnglish ? "Analysis deadline": "解析期限"}}</th>
            <td colspan="3"><input type="date" class="input-date" v-model="searchConditions.analysisDeadlineStart"/> ～ <input type="date" class="input-date" v-model="searchConditions.analysisDeadlineEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch" >{{isChangeEnglish ? "Search": "検索"}}</b-button>
          <b-button class="backbutton is-primary" @click="back">{{isChangeEnglish ? "Back": "戻る"}}</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult" >
        <template v-if="isChangeEnglish" >
          <span class="result-count">Number of cases: {{data.length}}</span>
          <b-table
            id="holterAnalysisResultTable"
            :data="data"
            :paginated="isPaginated"
            per-page="100"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="Reception number" width="80" sortable centered>
                <router-link :to="{name:'HolterAnalysisResultGuestDetail', params:{item:props.row, searchConditions:searchConditions, isChangeEnglish:isChangeEnglish}}"><a>{{props.row.receiptNumber}}</a></router-link>
              </b-table-column>
              <b-table-column field="returnDeadline" label="Requested return date" width="100" sortable centered>
                {{props.row.returnDeadline }}<span v-if="props.row.urgent" class="urgent" />
              </b-table-column>
              <b-table-column field="analysisDeadline" label="Analysis deadline" width="100" sortable centered>
                {{props.row.analysisDeadline }}
              </b-table-column>
              <b-table-column field="kind" label="Type" width="120" sortable >
                {{props.row.kind}}<span v-if="props.row.demo" class="demo" /><span v-if="props.row.depositMachineFlag" class="depo"/>
              </b-table-column>
              <b-table-column v-if="props.row.kind == 'ホルター心電図配送ｻｰﾋﾞｽ'" field="analysisMethod" label="Analysis method" width="180" sortable>
                ホルター心電図
              </b-table-column>
              <b-table-column v-if="props.row.kind == 'ホルター心電図解析ｻｰﾋﾞｽ'" field="analysisMethod" label="Analysis method" width="180" sortable>
                {{props.row.analysisMethod | analysisMethodFilter(analysisMethodList)}}
              </b-table-column>
              <b-table-column field="analysisMethod" label="Analysis option" width="200" sortable >
                {{props.row.analysisOption | analysisMethodFilter(analysisOptionList)}}
              </b-table-column>
              <b-table-column field="client" label="Client" width="200" sortable>
                {{props.row.client}}
              </b-table-column>
              <b-table-column field="hospital" label="Medical institution" width="200" sortable>
                {{props.row.hospital}}
              </b-table-column>
              <b-table-column field="patientName" label="Patient name" width="150" sortable>
                {{props.row.patientName}}
              </b-table-column>
              <b-table-column field="analysisStaffName" label="Analysis staff name" width="150" sortable>
                {{props.row.analysisStaffName}}
              </b-table-column>
              <b-table-column field="mailto" label="Contact" width="100" centered>
                <a @click="clipboardCopy(props.row.mailtoBody,props.row.mailto)">
                <b-icon icon="email-outline"/></a>
              </b-table-column>
              <b-table-column field="file" label="" width="20">
                <a @click="showReportArea(props.row.analysisResultFileList)">
                <b-icon icon="clipboard-file-outline" /></a>
              </b-table-column>
            </template>
          </b-table>
        </template>
        <template v-else>
          <span class="result-count">件数：{{data.length}}件</span>
          <b-table
            id="holterAnalysisResultTable"
            :data="data"
            :paginated="isPaginated"
            per-page="100"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="80" sortable centered>
                <router-link :to="{name:'HolterAnalysisResultGuestDetail', params:{item:props.row, searchConditions:searchConditions, isChangeEnglish:isChangeEnglish}}"><a>{{props.row.receiptNumber}}</a></router-link>
              </b-table-column>
              <b-table-column field="returnDeadline" label="返却希望日" width="100" sortable centered>
                {{props.row.returnDeadline }}<span v-if="props.row.urgent" class="urgent" />
              </b-table-column>
              <b-table-column field="analysisDeadline" label="解析期限" width="100" sortable centered>
                {{props.row.analysisDeadline }}
              </b-table-column>
              <b-table-column field="kind" label="種別" width="120" sortable >
                {{props.row.kind}}<span v-if="props.row.demo" class="demo" /><span v-if="props.row.depositMachineFlag" class="depo"/>
              </b-table-column>
              <b-table-column v-if="props.row.kind == 'ホルター心電図配送ｻｰﾋﾞｽ'" field="analysisMethod" label="解析方法" width="180" sortable>
                ホルター心電図
              </b-table-column>
              <b-table-column v-if="props.row.kind == 'ホルター心電図解析ｻｰﾋﾞｽ'" field="analysisMethod" label="解析方法" width="180" sortable>
                {{props.row.analysisMethod | analysisMethodFilter(analysisMethodList)}}
              </b-table-column>
              <b-table-column field="analysisMethod" label="解析オプション" width="200" sortable >
                {{props.row.analysisOption | analysisMethodFilter(analysisOptionList)}}
              </b-table-column>
              <b-table-column field="client" label="依頼元" width="200" sortable>
                {{props.row.client}}
              </b-table-column>
              <b-table-column field="hospital" label="医療機関" width="200" sortable>
                {{props.row.hospital}}
              </b-table-column>
              <b-table-column field="patientName" label="患者名" width="150" sortable>
                {{props.row.patientName}}
              </b-table-column>
              <b-table-column field="analysisStaffName" label="解析担当者" width="150" sortable>
                {{props.row.analysisStaffName}}
              </b-table-column>
              <b-table-column field="mailto" label="問い合わせ" width="100" centered>
                <a @click="clipboardCopy(props.row.mailtoBody,props.row.mailto)">
                <b-icon icon="email-outline"/></a>
              </b-table-column>
              <b-table-column field="file" label="" width="20">
                <a @click="showReportArea(props.row.analysisResultFileList)">
                <b-icon icon="clipboard-file-outline" /></a>
              </b-table-column>
            </template>
          </b-table>
        </template>
      </div>
    </div>
      <floatingModal name="detail-modal" modalClass="detail-modal" @close="closeDetail" title="" width="450" height="300" top="100px" right="100px">
        <downLoadFileList :fileList="fileListStr" :showNoteFlg="true" />
      </floatingModal>
  </div>
</template>

<script>
import floatingModal from "@/components/mock/common/FloatingModal";
import DownLoadFileList from "@/components/mock/common/DownLoadFileList";
import naviBar from "@/components/mock/philips/holterAnalysis/HolterAnalysisNaviBar";
import {choicesType} from "@/components/mock/base/const.js";

var data = [];
export default {
  name: "HolterAnalysisResult",
  methods: {
    back: function() {
      //外部ユーザーホーム
      this.$router.push({ path: "/guest/home" });
    },
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        if (this.isChangeEnglish){
          this.showErrorMessage("No search criteria entered.")
        } else {
          this.showErrorMessage("検索条件が入力されていません。")
        }
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getHolterAnalysisResultListPOST;
      var successCallBack = this.getHolterAnalysisResultListPOSTSuccess;
      var errorCallBack = this.getHolterAnalysisResultListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterAnalysisResultListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.externalHolterAnalysis.getHAnalysisResultListExternalPOST({
        body:obj
      });
    },
    getHolterAnalysisResultListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
      if(this.data && this.data.length > 0){
        var subject = encodeURI("ホルター心電図　緊急報告")
        const MAIL_PRJ_SCORING_CENTER = "Holter_analysis@philips.com"
        for(var item of this.data){
          item.mailtoBody = 
            item.hospitalName +" ご担当者様\n"
            + " \n"
            + "平素よりPhilips Care Portalをご利用いただきありがとうございます。 \n"
            + "ご依頼いただきましたホルター心電図データについて、下記の不整脈がみられたためご報告いたします。 \n"
            + "尚、このメールはホルター心電図自宅配送サービスをお申込いただきました、ご依頼元にのみ送信させて頂いております。\n"
            + " \n"
            + "【受付番号】" + item.receiptNumber +"\n"
            + "【依頼元】" + this.escapeStringForMailTo(item.client) +"\n"
            + "【医療機関】" + this.escapeStringForMailTo(item.hospital) +"\n"
            + "【検査種別】" + item.kind +"\n"
            + " \n"
            + "【不整脈の種類】\n"
            + "・心房細動/粗動\n"
            + "・3秒以上のポーズ\n"
            + "・2度房室ブロック　MobitzⅡ（モービッツ）型\n"
            + "・高度房室ブロック \n"
            + "・完全房室ブロック\n"
            + "・心室性頻拍（4連発以上）\n"
            + "・R on T \n"
            + "・心室細動\n"
            + "・頻脈190bpm以上が30秒以上持続\n"
            + "・徐脈35bpm未満が30秒以上持続\n"
            + "・失神/気を失った\n"
            + "・ペースメーカー機能不全疑い\n"
            + "\n"
            + "結果返却予定日は〇月〇日となります。\n"
            + "以上、宜しくお願いいたします。\n"
            + " \n"
            + "※オート解析での速報結果のため、最終結果とは異なる可能性があります。詳細につきましては、レポートにてご確認ください。\n"
            + "本メールは緊急報告のご連絡のみを目的としております。ご返信いただいても対応いたしかねますので、ご了承ください。\n"
            + " \n"
            + " \n"
            + "株式会社フィリップス・ジャパン　スコアリングセンター\n";
          item.ccAddressList.push(MAIL_PRJ_SCORING_CENTER)
          item.mailto = "mailto:" + item.clientlMailAddress + "?cc=" + item.ccAddressList.join(';') + "&subject=" + subject;
        }
      }
    },
    getHolterAnalysisResultListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function() {
      this.analysisMethodList = this.getChoiceList(this.choicesType.holterMethod, false);
      this.analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, false);
      this.analysisMethodList.unshift({})
      this.analysisOptionList.unshift({})
    },
    closeDetail: function(){
      this.$modal.hide('detail-modal')
    },
    showReportArea: function(fileList) {
      this.fileListStr = fileList;
      this.$modal.show('detail-modal')
    },
    clipboardCopy: function(mailtoBody,mailto){
      navigator.clipboard.writeText(mailtoBody).then(() => {
        this.$dialog.alert({
          title: '重要',
          message: '問合せメールの定型文をクリップボードに<br>コピーしました。<br>「OK」クリック後に新規メールが開きますので、<br>定型文を貼り付けてください。<br><br>The inquiry email template has been copied<br>to your clipboard.<br>After clicking "OK", a new email will open.<br>Please paste the template text.',
          onConfirm: () => {
            location.href = mailto;
          }
        })
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
      });
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var isChangeEnglish = this.$route.params["isChangeEnglish"];
    return {
      searchConditions:{
        receiptNumber:"",
         client:"",
         hospital:"",
         patientName:"",
         analysisStaffName:"",
         kind:"",
         demo: "",
         analysisMethod:"",
         analysisOptionList:"",
         returnDeadlineStart:"",
         returnDeadlineEnd:"",
         analysisDeadlineStart:"",
         analysisDeadlineEnd:"",
      },
      choicesType:choicesType,
      data: [],
      isPaginated: true,
      analysisMethodList:[],
      analysisOptionList:[],
      takeOverSearchParams,
      hasResult: false,
      fileListStr:"",
      isChangeEnglish:isChangeEnglish
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.getChoicesList();
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {
    analysisMethodFilter(value, analysisMethodList){
      var target = analysisMethodList.find(val => val.value == value)
      if(target){
        return target.label1
      }
      return ""
    },  
  },
  components: {
    holterAnalysisNavi: naviBar,
    floatingModal:floatingModal,
    downLoadFileList:DownLoadFileList
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  min-width: 200px;
}
.switch-area {
  display: flex;
}
.input-date {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/HolterAnalysisResultGuest.vue